import { fetchRequest } from "./Fetcher";

export const GetSignedUrl = async (gcsUri, expirationHours = 1) => {
  const { result } = await fetchRequest({
    path: `sessions/uploads/images/signed-url`,
    method: "POST",
    data: JSON.stringify({
      gcsUri: gcsUri,
      expiration_hours: expirationHours,
    }),
  });

  return result; // string
};

export const AttachSignedUrls = async (generatedImages = [], expirationHours = 1) => {
  const items = Array.isArray(generatedImages) ? generatedImages : [];

  const signedUrls = await Promise.all(
    items.map(async (it) => {
      const gcsUri = it?.imagePath || it?.gcsUri || it?.gcs_uri;
      if (!gcsUri) return "";
      try {
        return await GetSignedUrl(gcsUri, expirationHours);
      } catch (e) {
        console.error(e);
        return "";
      }
    })
  );

  return items.map((it, idx) => ({
    ...it,
    signed_url: signedUrls[idx] || it?.signed_url || "",
    url: signedUrls[idx] || it?.url || it?.signed_url || "",
    filename: it?.filename,
  }));
};

export const GetVideoSignedUrl = async (gcsUri, expirationHours = 1) => {
  const { result } = await fetchRequest({
    path: `sessions/uploads/videos/signed-url`,
    method: "POST",
    data: JSON.stringify({
      gcs_uri: gcsUri,
      expiration_hours: expirationHours,
    }),
  });

  return result;
};

export const AttachVideoSignedUrls = async (videos = [], expirationHours = 1) => {
  const items = Array.isArray(videos) ? videos : [];

  const signedUrls = await Promise.all(
    items.map(async (it) => {
      const gcsUri = it?.gcs_uri || it?.gcsUri || it?.output?.gcsUri;
      if (!gcsUri) return "";
      try {
        return await GetVideoSignedUrl(gcsUri, expirationHours);
      } catch (e) {
        console.error(e);
        return "";
      }
    })
  );

  return items.map((it, idx) => ({
    ...it,
    signed_url: signedUrls[idx] || it?.signed_url || "",
    url: signedUrls[idx] || it?.url || it?.signed_url || "",
  }));
};

